import Button from 'components/Button'
import Control from 'components/Control/Control'
import Flex from 'components/Flex'
import UploadIcon from 'components/icons/UploadIcon'
import React, { Fragment } from 'react'
import ErrorMessage from 'utils/ErrorMessage'

import {
  AddIcon,
  SmallButtons,
  SpanText,
  StyledH2,
  StyledUpload,
  TextWrapper,
  UploadText,
  Wrapper,
} from 'components/Uploader/Styles'
import Add from 'components/icons/Add'
import { deleteFile, uploadFile } from 'modules/Drive/actions'
import { useDispatch } from 'react-redux'

const Uploader = ({
  isDelete,
  file,
  setFile,
  isDefault = false,
  showTextUploder,
  showButtonUpLoader,
  fileName,
  format,
  setFileURL,
  message,
  isWhiteDesign,
  customHeight,
  setIsPreviewJD,
  handleFileChange,
  showButtonType,
  multiple,
  pointerEventDisable,
  disabled = false,
  notAllowedCursor = false,
}) => {
  const dispatch = new useDispatch()

  const getFileUrl = async info => {
    let getType = info?.file?.type?.includes('xlsx') ? 'xlsx' : 'csv'
    let name = fileName + '.' + getType
    let response = await dispatch(uploadFile(info?.file?.originFileObj, name))
    if (response) {
      setFile(response)
    }
  }

  const props = {
    name: 'file',
    multiple: false,
    listType: 'picture',
    accept: '.xlsx',
    beforeUpload: file => {
      const isLt10mb = file.size / 1024 / 1024 < 10
      if (!isLt10mb) {
        ErrorMessage('Image must smaller than 10mb!')
        return false
      } else if (!file?.type.includes('xlsx') && !file?.type.includes('csv')) {
        ErrorMessage(
          message ?? 'File should be in xlsx/csv/jpeg/png/ppt/doc  format!'
        )
        return false
      }
    },
    onChange: async info => {
      if (isDelete && info?.file?.status === 'done') {
        let response = await dispatch(deleteFile(file))
        if (response) {
          return getFileUrl(info)
        }
      } else if (!isDelete && info?.file?.status === 'done') {
        return getFileUrl(info)
      }
    },
    itemRender: () => {},
  }

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess('OK')
    }, 0)
  }

  const onBeforeUpload = file => {
    const isLt10mb = file.size / 1024 / 1024 < 2

    if (!isLt10mb) {
      ErrorMessage('File must smaller than 2mb!')
      return false
    } else if (
      !file?.type.includes('spreadsheetml') &&
      !file?.type.includes('jpeg') &&
      !file?.type?.includes('jpg') &&
      !file?.type?.includes('png') &&
      !file?.type?.includes('msword') &&
      !file?.type?.includes('powerpoint') &&
      !file?.type?.includes('presentation') &&
      !file?.type?.includes('doc') &&
      !file?.type?.includes('pdf') &&
      !file?.type?.includes('csv')
    ) {
      ErrorMessage(message ?? 'File should be in xlsx/csv  format!')
      return false
    }
  }

  const onChangeFileUpload = async info => {
    if (info?.file?.status === 'done') {
      const originFile = info?.file?.originFileObj

      let getType = info?.file?.type?.includes('spreadsheetml')
        ? 'xlsx'
        : info?.file?.type?.includes('msword')
        ? 'doc'
        : info?.file?.type?.includes('png')
        ? 'png'
        : info?.file?.type?.includes('powerpoint')
        ? 'ppt'
        : info?.file?.type?.includes('jpg')
        ? 'jpg'
        : info?.file?.type?.includes('jpeg')
        ? 'jpeg'
        : info?.file?.type?.includes('pdf')
        ? 'pdf'
        : info?.file?.type?.includes('doc')
        ? 'doc'
        : 'csv'

      let name = info?.file?.name
      const clonedFile = new File([originFile], originFile.name, {
        type: getType,
        lastModified: originFile.lastModified,
      })

      if (handleFileChange) {
        handleFileChange(clonedFile)
      }
      const formatArray = format
        ?.split(',')
        .map(ext => ext.trim().replace(/[()]/g, ''))

      if (formatArray.some(ext => name.includes(ext))) {
        const response = await dispatch(uploadFile(originFile, name))

        if (response) {
          let fileObject = {
            name,
            url: response,
            size: info?.file?.size,
            date: new Date().getTime(),
            type: getType,
          }

          if (multiple) {
            setFile(file => [...file, fileObject])
            setFileURL(fileResponse => [...fileResponse, response])
          } else {
            setFile([fileObject])
            setFileURL([response])
          }

          if (setIsPreviewJD) {
            setIsPreviewJD(true)
          }
        }
      }
    }
  }

  return (
    <Fragment>
      {isDefault && (
        <StyledUpload
          {...props}
          multiple={multiple ? true : false}
          type="file"
          accept={'.docx,.doc, .pdf'}
          customRequest={dummyRequest}
          onChange={onChangeFileUpload}
          beforeUpload={onBeforeUpload}
          disabled={disabled}
        >
          <Wrapper
            isWhiteDesign={isWhiteDesign}
            customHeight={customHeight}
            center
            alignCenter
            column
            pointerEventDisable={pointerEventDisable}
            notAllowedCursor={notAllowedCursor}
          >
            <Flex center width="100%">
              <SmallButtons
                height={'38px'}
                width="38px"
                border={true}
                icon={<UploadIcon />}
                disabled={disabled}
              />
            </Flex>
            <TextWrapper center alignCenter>
              <StyledH2>Browse for file or Drag and drop </StyledH2>
            </TextWrapper>
            <TextWrapper center alignCenter padding={'9px 0px'}>
              {}
              <SpanText>Format {format ?? ': .xlsx'}</SpanText>
            </TextWrapper>
          </Wrapper>
        </StyledUpload>
      )}
      {showTextUploder && (
        <StyledUpload {...props} type="file" customRequest={dummyRequest}>
          <Control center alignCenter top="5px">
            <AddIcon>
              <Add />
            </AddIcon>
            <UploadText>Upload File</UploadText>
          </Control>
        </StyledUpload>
      )}
      {showButtonUpLoader && (
        <StyledUpload
          {...props}
          multiple={multiple ? true : false}
          type="file"
          accept={'.docx,.doc, .pdf'}
          customRequest={dummyRequest}
          onChange={onChangeFileUpload}
          beforeUpload={onBeforeUpload}
        >
          {showButtonType === 'secondary' ? (
            <Button.Secondary text="Upload another file" width="233px" />
          ) : (
            <Button.Primary text="Change" height={'32px'} />
          )}
        </StyledUpload>
      )}
    </Fragment>
  )
}

export default Uploader
